import { useEffect, useState } from 'react';
import { ImageOff } from 'lucide-react';

interface MediaImageProps {
  src?: string | null;
  alt: string;
  className?: string;
  fallbackClassName?: string;
  iconClassName?: string;
}

/**
 * Designed fallback when a cover or thumbnail is missing.
 * The img itself has an empty alt so a failed load never shows broken alt text.
 */
export function MediaImage({
  src,
  alt,
  className = '',
  fallbackClassName,
  iconClassName = 'h-8 w-8',
}: MediaImageProps) {
  const [failed, setFailed] = useState(!src);

  useEffect(() => {
    setFailed(!src);
  }, [src]);

  if (failed || !src) {
    return (
      <div
        role="img"
        aria-label={alt}
        className={`flex items-center justify-center bg-[var(--xd-raised)] text-[var(--xd-fg-4)] ${fallbackClassName ?? className}`}
      >
        <ImageOff className={iconClassName} strokeWidth={1.5} aria-hidden />
      </div>
    );
  }

  return <img src={src} alt="" className={className} onError={() => setFailed(true)} />;
}
